/* Glisser (snippets/glisser.liquid) : moteur commun des pistes qui défilent de côté (groupes défilants,
   onglets, frise, avis du tiroir panier). ES5, une seule fois (window.Glisser). Mode d'emploi : snippets/glisser.liquid. */
(function () {
  if (window.Glisser) return;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function doux() { return !(mq && mq.matches); }
  function tableau(l) { return Array.prototype.slice.call(l || []); }
  function rtl(el) { return getComputedStyle(el).direction === 'rtl'; }

  /* un élément qui défile lui-même de côté (tableau large, autre carrousel) garde son geste */
  function defilantInterne(t, piste) {
    for (var el = t; el && el !== piste; el = el.parentElement) {
      if (el.scrollWidth > el.clientWidth + 1) {
        var o = getComputedStyle(el).overflowX;
        if (o === 'auto' || o === 'scroll') return true;
      }
    }
    return false;
  }

  /* copie sans ses feuilles de style : les <style> d'une carte sont globaux et restent dans la vraie
     carte ; chaque double ajouté faisait recalculer les styles de toute la page (Safari surtout). Un
     <template> vide garde leur place (sélecteurs :first-child, + … inchangés). */
  function sansFeuilles(x) {
    tableau(x.querySelectorAll('style')).forEach(function (s) {
      if (s.parentNode) s.parentNode.replaceChild(document.createElement('template'), s);
    });
  }

  /* copie de boucle : jamais comptée comme une carte */
  function estCopie(c) { return !!(c && c.hasAttribute && c.hasAttribute('data-gl-clone')); }
  function estCarte(c) { return !estCopie(c) && !/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(c.tagName); }

  /* un clic ou une touche n'importe où (point de frise, bouton extérieur qui fait défiler une piste…) :
     le défilement de piste qui suit est voulu par le visiteur (voir reprise()) */
  var dernierClic = -Infinity;
  function noterClic() { dernierClic = window.performance && performance.now ? performance.now() : Date.now(); }
  document.addEventListener('click', noterClic, true);
  document.addEventListener('keydown', noterClic, true);

  function brancher(p, o) {
    if (p.__gl) {
      if (o) p.__gl.o = o;
      return p.__gl;
    }
    var api = { o: o || {}, i: 0, cible: null, tire: false };
    p.__gl = api;
    p.setAttribute('data-gl-piste', '');
    /* repère commun des zones qui défilent de côté (ignorées par les contrôles de débordement) */
    p.setAttribute('data-defile', '');

    /* ═══ La piste ne bouge que sous la main du visiteur ═══
       Safari et Chrome sur iPhone (WebKit) peuvent « ré-aimanter » d'eux-mêmes une piste sur un cran
       mémorisé et périmé (constaté sur le carrousel d'avis : la 3e carte qui s'affiche seule). Un
       défilement sans geste du visiteur (doigt, souris, molette, clavier, focus) ni glissement commandé
       (flèche, pastille, onglet, lecture auto) n'est donc pas adopté : la piste est remise, à
       l'HORIZONTALE seulement, sur sa position de repos. La page n'est jamais touchée. */
    var GESTE_MS = 400;
    var gesteT = -Infinity;  /* dernier signe d'un geste (élan compris : chaque défilement accepté prolonge) */
    var repos = null;        /* position de repos (scrollLeft) : là où le visiteur ou le thème l'a laissée */
    var reprises = [];       /* garde-fou : jamais de bras de fer avec le navigateur */
    var COMMANDE_MS = 1500;
    var commandeT = -Infinity; /* début du dernier glissement doux commandé (flèche, pastille, lecture auto) */
    function maintenant() { return window.performance && performance.now ? performance.now() : Date.now(); }
    function noterGeste() { gesteT = maintenant(); }
    function noterRepos() { repos = p.scrollLeft; recalerAimant(); }
    /* ═══ L'« aimant » du navigateur suit la piste ═══
       WebKit (Safari, Chrome iPhone) retient le cran de la dernière accroche faite PAR LUI et y ramène la
       piste après une mise en page (rotation, carrousel qui réapparaît) ; les poses faites par le code
       (point, flèche, boucle, lecture auto) ne le mettent pas à jour. Couper l'accroche le temps d'une mise
       en page efface ce cran ; rétablie, elle repart de la position réelle (remise au pixel près : rien ne
       bouge à l'écran). Jamais sous le doigt, la souris ou pendant un glissement commandé. */
    var aimantX = NaN, aimantL = NaN;
    function remettre(x) { if (Math.abs(p.scrollLeft - x) > 0.5) p.scrollLeft = x; }
    function recalerAimant() {
      if (doigt || api.tire || st || api.cible !== null || p.classList.contains('est-libre')) return;
      var x = p.scrollLeft, w = p.clientWidth;
      if (Math.abs(x - aimantX) <= 0.5 && w === aimantL) return;
      aimantX = x; aimantL = w;
      p.classList.add('est-libre');
      void p.offsetWidth;
      remettre(x);
      p.classList.remove('est-libre');
      void p.offsetWidth;
      remettre(x);
    }
    /* déplacement instantané fait par le thème : c'est aussitôt la nouvelle position de repos */
    function poserX(x) { p.scrollLeft = x; noterRepos(); }

    function liste() { return tableau(api.o.items ? api.o.items() : p.children).filter(estCarte); }
    /* écart entre le début de la carte et le début de la zone visible de la piste */
    function ecart(c) {
      var a = c.getBoundingClientRect();
      var b = p.getBoundingClientRect();
      return rtl(p) ? a.right - b.right : a.left - b.left;
    }

    /* ═══ Boucle (option « boucle ») ═══
       Des COPIES des dernières cartes sont posées en tête et des premières en queue : on glisse dans les
       deux sens sans buter ni rembobiner. Posée sur une copie, la piste se replace d'un tour complet,
       instantanément, sur la vraie carte (même image au pixel près). Les indices donnés aux rappels
       (suivre, change) et renvoyés par indice() sont toujours ceux des VRAIES cartes. */
    var B = null;          /* { n, k, vues, tete, queue, cle } */
    var doigt = false;     /* doigt posé : on ne replace pas sous le doigt */
    var depuis = 0;        /* début du glissement commandé en cours */
    function mod(v, n) { return ((v % n) + n) % n; }
    function el(v) {
      var l = liste();
      if (!B) return l[v] || null;
      if (v < 0) return B.tete[B.k + v] || null;
      if (v >= B.n) return B.queue[v - B.n] || null;
      return l[v] || null;
    }
    /* la carte (vraie ou copie) posée au début de la piste, en position virtuelle */
    function proche() {
      if (!B) return null;
      var meilleur = null;
      var d = Infinity;
      for (var v = -B.k; v < B.n + B.k; v++) {
        var c = el(v);
        if (!c) continue;
        var e = Math.abs(ecart(c));
        if (e < d) { d = e; meilleur = { v: v, el: c }; }
      }
      return meilleur;
    }
    function boucleVoulue(l) {
      var b = api.o.boucle;
      if (!(typeof b === 'function' ? b() : b)) return false;
      if (l.length < 2 || !p.clientWidth) return false;
      var min = Infinity;
      var max = -Infinity;
      for (var k = 0; k < l.length; k++) {
        var r = l[k].getBoundingClientRect();
        if (!r.width) return false;
        if (r.left < min) min = r.left;
        if (r.right > max) max = r.right;
      }
      return max - min > p.clientWidth + 1;
    }
    function copier(c, reel, loin) {
      var x = c.cloneNode(true);
      sansFeuilles(x);
      tableau([x].concat(tableau(x.querySelectorAll('*')))).forEach(function (n) {
        tableau(n.attributes).forEach(function (a) {
          if (a.name === 'id' || a.name.indexOf('data-shopify') === 0 || a.name === 'data-avis-carte' || a.name === 'data-avis-point') n.removeAttribute(a.name);
        });
        if (n !== x && n.matches && n.matches('a[href], button, input, select, textarea, iframe, summary, [tabindex], video[controls]')) n.setAttribute('tabindex', '-1');
        if (n.tagName === 'IMG') { n.setAttribute('loading', 'lazy'); n.removeAttribute('fetchpriority'); }
        /* copies au-delà d'un tour (vues seulement pendant un long élan) : pas de vidéo qui se charge ou se lit */
        if (loin && n.tagName === 'VIDEO') { n.removeAttribute('autoplay'); n.setAttribute('preload', 'none'); }
      });
      x.setAttribute('data-gl-clone', '');
      x.setAttribute('data-gl-reel', String(reel));
      x.setAttribute('aria-hidden', 'true');
      x.setAttribute('tabindex', '-1');
      return x;
    }
    function retirerCopies() {
      tableau(p.children).forEach(function (c) { if (estCopie(c)) p.removeChild(c); });
      B = null;
    }
    /* décalage instantané (un tour complet : l'image ne change pas) ; l'aimantation est coupée par
       est-libre, sinon le navigateur ré-aimanterait un saut fait en plein glissement */
    function sauter(dx) {
      if (!dx) return;
      p.classList.add('est-libre');
      poserX(p.scrollLeft + dx);
    }
    /* se poser tout de suite sur la vraie carte i */
    function caler(i) {
      var c = liste()[i];
      if (!c) return;
      var dx = ecart(c);
      if (Math.abs(dx) >= 1) poserX(p.scrollLeft + dx);
    }
    /* ajoute, reconstruit ou retire les copies selon l'état courant */
    api.boucleMaj = function (garder) {
      var l = liste();
      var voulue = boucleVoulue(l);
      var n = l.length;
      var k = 0;
      var vues = 1;
      if (voulue) {
        var r0 = l[0].getBoundingClientRect();
        var pas = Math.abs(l[1].getBoundingClientRect().left - r0.left) || r0.width || 1;
        vues = Math.max(1, Math.ceil((p.clientWidth - 1) / pas));
        /* de quoi enchaîner plusieurs glissés forts dans le même sens sans jamais buter, même si l'élan ne
           laisse pas le temps de se replacer (au-delà de n, les copies reprennent le cycle). 8 de chaque
           côté quel que soit le nombre de cartes (au moins 2 écrans + 1) : essayé au doigt, 3 glissés
           forts enchaînés (10 000 px/s) : aucune butée à 8 ; à 6, une butée sur ~56 gestes ; à 3, la
           piste bute souvent. Ne pas descendre sous 8 (à 2 cartes, « 3 tours » n'en ferait que 6). */
        k = Math.max(2 * vues + 1, 8);
      }
      var cle = voulue ? n + ':' + k : '';
      var intactes = !!B && B.cle === cle && B.tete.concat(B.queue).every(function (c) { return c.parentNode === p; });
      if (voulue && intactes) return;
      var avait = !!B || tableau(p.children).some(estCopie);
      if (!voulue && !avait) return;
      /* carte à garder : celle qu'on voit si la boucle tourne déjà ; sinon la dernière connue (à l'entrée
         dans le carrousel, le navigateur a pu ré-aimanter la piste n'importe où) */
      var i = typeof garder === 'number' ? Math.min(Math.max(0, garder), Math.max(0, n - 1)) : B ? api.indice() : Math.min(api.i, Math.max(0, n - 1));
      retirerCopies();
      if (voulue) {
        var tete = [];
        var queue = [];
        var v;
        for (v = -k; v < 0; v++) tete.push(copier(l[mod(v, n)], mod(v, n), v < -n));
        for (v = 0; v < k; v++) queue.push(copier(l[v % n], v % n, v >= n));
        tete.forEach(function (c) { p.insertBefore(c, l[0]); });
        var apres = l[n - 1].nextSibling;
        queue.forEach(function (c) { p.insertBefore(c, apres); });
        B = { n: n, k: k, vues: vues, tete: tete, queue: queue, cle: cle };
      }
      if (voulue || p.scrollWidth > p.clientWidth + 1) caler(i);
      api.i = i;
    };
    api.enBoucle = function () { return !!B; };

    /* glisse jusqu'à la position « voulu » (virtuelle), en continuant dans le même sens depuis ce qu'on voit */
    function allerV(voulu, anime) {
      var pr = proche();
      if (!pr) return;
      var n = B.n;
      var bas = -B.k;
      var haut = n + B.k - B.vues;
      var geo = pr.v;
      /* clics très rapides qui s'accumulent : jamais plus d'un tour de trajet (on ne fait pas défiler
         toutes les cartes plusieurs fois) — même carte d'arrivée */
      if (Math.abs(voulu - geo) > n) voulu -= (voulu > geo ? 1 : -1) * n * Math.ceil((Math.abs(voulu - geo) - n) / n);
      var sens = voulu > geo ? 1 : voulu < geo ? -1 : 0;
      var t = null;
      var saut = 0;
      /* sauts possibles : aucun, un tour, ou le retour dans les vraies cartes (s0) s'il en faut plusieurs */
      var s0 = mod(geo, n) - geo;
      for (var tours = 0; tours < 3 && t === null; tours++) {
        var essais = [0, -n, n, s0, s0 - n, s0 + n];
        for (var j = 0; j < essais.length; j++) {
          var s = essais[j];
          var essai = voulu - sens * tours * n + s;
          var vue = geo + s;
          if (vue >= bas && vue <= haut && essai >= bas && essai <= haut && (essai - vue) * sens >= 0) { t = essai; saut = s; break; }
        }
      }
      if (t === null) t = mod(voulu, n);
      else if (saut) {
        var vers = el(geo + saut);
        if (vers) sauter(ecart(vers) - ecart(pr.el));
      }
      var c = el(t);
      if (!c) return;
      api.i = mod(t, n);
      var dx = ecart(c);
      if (Math.abs(dx) < 1) {
        api.cible = null;
        p.classList.remove('est-libre');
        planifierPose();
        return;
      }
      api.cible = t;
      depuis = Date.now();
      var but = p.scrollLeft + dx;
      if (anime === false || !doux() || typeof p.scrollTo !== 'function') poserX(but);
      else { commandeT = maintenant(); p.scrollTo({ left: but, behavior: 'smooth' }); }
    }
    /* base d'un pas : la cible en cours, sinon ce qu'on voit */
    function base() {
      if (api.cible !== null) return api.cible;
      var pr = proche();
      return pr ? pr.v : api.i;
    }

    api.indice = function () {
      if (B) {
        var pr = proche();
        return pr ? mod(pr.v, B.n) : api.i;
      }
      var l = liste();
      var best = 0;
      var d = Infinity;
      for (var k = 0; k < l.length; k++) {
        var e = Math.abs(ecart(l[k]));
        if (e < d) { d = e; best = k; }
      }
      return best;
    };

    api.aller = function (i, anime) {
      if (B) {
        /* carte réelle i : par le plus court chemin (copies comprises) */
        var b0 = base();
        var d = mod(i, B.n) - mod(b0, B.n);
        if (d > B.n / 2) d -= B.n;
        else if (d < -B.n / 2) d += B.n;
        allerV(b0 + d, anime);
        return;
      }
      var l = liste();
      if (!l.length) return;
      i = Math.max(0, Math.min(l.length - 1, i));
      api.i = i;
      var dx = ecart(l[i]);
      if (Math.abs(dx) < 1) {
        api.cible = null;
        p.classList.remove('est-libre');
        return;
      }
      api.cible = i;
      var but = p.scrollLeft + dx;
      if (anime === false || !doux() || typeof p.scrollTo !== 'function') poserX(but);
      else { commandeT = maintenant(); p.scrollTo({ left: but, behavior: 'smooth' }); }
    };

    /* d cartes plus loin (flèches, clavier, lecture auto) : en boucle, toujours dans ce sens */
    api.pas = function (d, anime) {
      if (B) { allerV(base() + d, anime); return; }
      api.aller(api.i + d, anime);
    };

    /* ——— largeur qui change (rotation d'écran, tiroir rouvert) : on reste sur la même carte ———
       La position de repos (scrollLeft) ne vaut que pour une largeur. Entre la nouvelle mise en page et le
       passage de l'observateur de taille, le navigateur recale la piste comme il peut : ces défilements ne
       sont ni remis (ce serait une autre carte) ni adoptés ; puis la piste est reposée sur la carte d'AVANT
       le changement (api.i : aucun défilement sans geste ne l'a modifiée entre-temps). */
    var largeur = -1;
    var minuterieLargeur = null;
    function largeurMaj() {
      clearTimeout(minuterieLargeur);
      var w = p.clientWidth;
      if (w === largeur) return;
      largeur = w;
      if (w > 0 && !api.tire) {
        var i = api.i;
        if (api.o.boucle || B) api.boucleMaj(i);
        /* sous le doigt, le visiteur mène : copies refaites seulement */
        if (!doigt) {
          caler(i);
          api.i = i;
          api.cible = null;
        }
      }
      noterRepos();
    }
    function largeurEnAttente() {
      if (largeur === -1 || !window.ResizeObserver || p.clientWidth === largeur) return false;
      /* l'observateur passe d'ordinaire dans la même image ; filet de sécurité s'il ne venait pas */
      clearTimeout(minuterieLargeur);
      minuterieLargeur = setTimeout(largeurMaj, 200);
      return true;
    }

    /* ——— fin du défilement : la piste s'est posée ——— */
    var minuterie = null;
    function planifierPose() {
      clearTimeout(minuterie);
      minuterie = setTimeout(pose, 160);
    }
    function pose() {
      clearTimeout(minuterie);
      minuterie = null;
      if (api.tire || (doigt && B)) return;
      if (B) {
        /* glissement commandé pas encore arrivé (départ lent) : on attend */
        if (api.cible !== null) {
          var c = el(api.cible);
          if (c && Math.abs(ecart(c)) > 2 && Date.now() - depuis < 1500) { planifierPose(); return; }
        }
        var pr = proche();
        if (pr && (pr.v < 0 || pr.v > B.n - 1)) {
          var jumeau = el(mod(pr.v, B.n));
          if (jumeau) sauter(ecart(jumeau) - ecart(pr.el));
        }
      }
      p.classList.remove('est-libre');
      var i = api.indice();
      api.cible = null;
      api.i = i;
      noterRepos();
      if (api.o.change) api.o.change(i);
    }
    /* le défilement vient-il du visiteur (geste, élan, clic) ou d'un glissement commandé ? sinon, du navigateur seul */
    function voulu() {
      var t = maintenant();
      if (doigt || api.tire || st || t - gesteT < GESTE_MS || t - dernierClic < GESTE_MS) { gesteT = t; return true; }
      /* glissement commandé en route (le navigateur peut marquer des pauses : la pose a pu passer avant l'arrivée) */
      return api.cible !== null || t - commandeT < COMMANDE_MS;
    }
    /* défilement du navigateur seul : remise en place, rien n'est adopté (true) ; false : garde-fou atteint */
    function reprise() {
      if (repos === null) return false;
      /* piste à sa position de repos : rien de nouveau à adopter (surtout pas une carte recalculée d'après
         une autre mise en page, ex. toutes les cartes visibles en paysage) */
      if (Math.abs(p.scrollLeft - repos) <= 1) return true;
      var t = maintenant();
      reprises = reprises.filter(function (x) { return t - x < 3000; });
      if (reprises.length >= 4) return false;
      reprises.push(t);
      p.scrollLeft = repos;
      return true;
    }
    p.addEventListener('scroll', function () {
      if (largeurEnAttente()) return;
      if (!voulu() && reprise()) return;
      /* pendant un glissement commandé (clic sur un onglet), les cartes traversées ne comptent pas */
      if (api.cible === null && api.o.suivre) api.o.suivre(api.indice());
      clearTimeout(minuterie);
      minuterie = setTimeout(pose, 160);
    }, { passive: true });
    if ('onscrollend' in window) p.addEventListener('scrollend', function () {
      if (largeurEnAttente()) return;
      /* fin d'un défilement du navigateur seul, déjà remis en place : rien à poser */
      if (!voulu() && repos !== null && Math.abs(p.scrollLeft - repos) <= 1) return;
      pose();
    });

    /* doigt reposé avant la fin de l'élan (glissés enchaînés) : on se replace TOUT DE SUITE sur la vraie
       carte si le navigateur le permet (Chrome finit parfois son élan avant de céder au doigt : le saut
       est alors ignoré, sans effet visible ; c'est la réserve de copies qui évite la butée). Aimantation
       coupée le temps du saut seulement (sinon le navigateur le ré-aimanterait). */
    function recentrerDoigt() {
      var pr = proche();
      if (!pr || (pr.v >= 0 && pr.v <= B.n - 1)) return;
      var jumeau = el(mod(pr.v, B.n));
      if (!jumeau) return;
      p.classList.add('est-libre');
      poserX(p.scrollLeft + ecart(jumeau) - ecart(pr.el));
      p.classList.remove('est-libre');
    }

    /* ——— doigt : le navigateur fait glisser ; on prévient seulement (pause des rotations) ——— */
    p.addEventListener('touchstart', function () {
      doigt = true;
      noterGeste();
      if (B) {
        api.cible = null;
        recentrerDoigt();
      }
      if (api.o.toucher) api.o.toucher(true);
    }, { passive: true });

    function doigtLeve() {
      doigt = false;
      /* doigt levé : l'élan qui suit fait partie du geste */
      noterGeste();
      /* en boucle : sans élan, plus aucun défilement ne viendra, on se pose nous-mêmes */
      if (B) planifierPose();
      if (api.o.toucher) api.o.toucher(false);
    }
    p.addEventListener('touchend', doigtLeve, { passive: true });
    p.addEventListener('touchcancel', doigtLeve, { passive: true });
    /* doigt levé dont la piste n'a pas reçu la fin (carte retirée sous le doigt…) : jamais de doigt « collé » */
    function finAilleurs(e) {
      if (!doigt || p.contains(e.target)) return;
      if (e.type !== 'touchstart' && e.touches && e.touches.length) return;
      doigtLeve();
    }
    document.addEventListener('touchend', finAilleurs, { capture: true, passive: true });
    document.addEventListener('touchcancel', finAilleurs, { capture: true, passive: true });
    document.addEventListener('touchstart', finAilleurs, { capture: true, passive: true });

    /* ——— souris : attraper et faire glisser ——— */
    var st = null;
    p.addEventListener('pointerdown', function (e) {
      noterGeste();
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var t = e.target;
      if (t.closest && t.closest('input, textarea, select, button, summary, [contenteditable], [data-gl-ignorer]')) return;
      if (defilantInterne(t, p)) return;
      var pr0 = proche();
      st = { x: e.clientX, y: e.clientY, g: p.scrollLeft, i: api.indice(), v: pr0 ? pr0.v : api.indice(), dx: 0, bouge: false, id: e.pointerId };
      if (B) api.cible = null;
    });
    p.addEventListener('pointermove', function (e) {
      if (!st || e.pointerId !== st.id) return;
      var dx = e.clientX - st.x;
      var dy = e.clientY - st.y;
      if (!st.bouge) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { st = null; return; }
        st.bouge = true;
        api.tire = true;
        try { p.setPointerCapture(e.pointerId); } catch (err) {}
        p.classList.add('est-tire', 'est-libre');
        if (api.o.toucher) api.o.toucher(true);
      }
      st.dx = dx;
      e.preventDefault();
      p.scrollLeft = st.g - dx;
      /* en boucle, la souris tire sans fin : sur une copie, on se replace d'un tour (même image) */
      if (B) {
        var pr = proche();
        if (pr && (pr.v < 0 || pr.v > B.n - 1)) {
          var s = mod(pr.v, B.n) - pr.v;
          var jumeau = el(pr.v + s);
          if (jumeau) {
            var dj = ecart(jumeau) - ecart(pr.el);
            st.g += dj;
            st.v += s;
            poserX(st.g - dx);
          }
        }
      }
    });
    function lacher(e) {
      if (!st || (e && e.pointerId !== st.id)) return;
      var s = st;
      st = null;
      if (!s.bouge) return;
      api.tire = false;
      p.classList.remove('est-tire');
      var seuil = Math.min(60, p.clientWidth * 0.12);
      var sens = rtl(p) ? -1 : 1;
      var i = s.i;
      var pasFait = 0;
      if (s.dx * sens < -seuil) pasFait = 1;
      else if (s.dx * sens > seuil) pasFait = -1;
      if (B) allerV(s.v + pasFait, true);
      else api.aller(i + pasFait, true);
      if (api.cible === null) pose();
      if (api.o.toucher) api.o.toucher(false);
      /* le relâcher d'un glissement n'est pas un clic (lien, carte…) */
      p.__glSansClic = true;
      setTimeout(function () { p.__glSansClic = false; }, 0);
    }
    p.addEventListener('pointerup', lacher);
    p.addEventListener('pointercancel', lacher);
    p.addEventListener('click', function (e) {
      if (p.__glSansClic) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    p.addEventListener('dragstart', function (e) { if (st) e.preventDefault(); });
    /* molette / pavé tactile de côté, clavier, focus : gestes du visiteur */
    p.addEventListener('wheel', function (e) {
      if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) noterGeste();
    }, { passive: true });
    p.addEventListener('keydown', noterGeste);
    p.addEventListener('focusin', noterGeste);

    /* ——— largeur qui change : voir largeurMaj() ——— */
    if (window.ResizeObserver) new ResizeObserver(largeurMaj).observe(p);
    if (api.o.boucle) api.boucleMaj();
    if (repos === null) noterRepos();

    return api;
  }

  window.Glisser = {
    brancher: brancher,
    doux: doux
  };

  /* ═══ Avis du panier (blocks/cart-social-proof) ═══
     La rotation reste celle du script du tiroir (snippets/cart-drawer.liquid) : il pose la classe
     est-actif, aria-pressed sur les pastilles et data-avis-i. On y ajoute la piste : la carte
     désignée arrive en glissant, et un glissement au doigt ou à la souris met à jour la même
     carte active (et remet l'horloge du tiroir à zéro). Sans ce script, l'avis reste en fondu. */
  function monterAvisPanier(el) {
    var p = el.querySelector('.avp__pile');
    if (!p) return;
    function cartes() { return tableau(el.querySelectorAll('[data-avis-carte]')); }
    function courant() { return parseInt(el.getAttribute('data-avis-i'), 10) || 0; }
    el.setAttribute('data-gl', '');
    var api = brancher(p, {
      items: cartes,
      change: function (i) {
        if (i === courant()) return;
        cartes().forEach(function (c, j) { c.classList.toggle('est-actif', j === i); });
        tableau(el.querySelectorAll('[data-avis-point]')).forEach(function (b, j) {
          b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        });
        el.setAttribute('data-avis-i', String(i));
        el.__t = 0;
      },
      /* doigt posé : l'horloge du tiroir ne peut pas atteindre l'intervalle */
      toucher: function (oui) { el.__t = oui ? -100000 : 0; }
    });
    if (!el.__glMO && window.MutationObserver) {
      el.__glMO = new MutationObserver(function () {
        var i = courant();
        if (api.cible === null && api.indice() !== i) api.aller(i, true);
        else api.i = i;
      });
      el.__glMO.observe(el, { attributes: true, attributeFilter: ['data-avis-i'] });
    }
    api.aller(courant(), false);
  }

  var attente = false;
  function scanner() {
    attente = false;
    tableau(document.querySelectorAll('[data-avis-panier]:not([data-gl])')).forEach(monterAvisPanier);
  }
  function planifier() {
    if (attente) return;
    attente = true;
    (window.requestAnimationFrame || setTimeout)(scanner);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanner);
  else scanner();
  if (window.MutationObserver) {
    /* le tiroir redessiné (ou un attribut data-gl effacé par la mise à jour) : on rebranche */
    new MutationObserver(planifier).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['data-gl']
    });
  }
  document.addEventListener('shopify:section:load', planifier);
})();
